<script setup lang="ts">
import {onBeforeMount, PropType, ref} from "vue";
import {ICellRendererParams} from "ag-grid-community";
import ReportLauncherPlace from "@/utils/presenters/ReportLauncherPlace.ts";
import DomainBaseEntities from "@/utils/constants/DomainBaseEntities.ts";
import NamaCommon from "@/utils/common/NamaCommon.ts";
import NamaURLS from "@/utils/constants/NamaURLS.ts";
import RouteNames from "@/router/RouteNames.ts";
import router from "@/router";
import Translator from "@/utils/common/Translator.ts";
import ByIdRequest = namaTypes.ByIdRequest;

const props = defineProps({
  params: {
    type: Object as PropType<ICellRendererParams>,
    required: true
  }
});

const fieldValue = props.params.value;
let reportRef = ref({})
onBeforeMount(async () => {
  let request: ByIdRequest = {
    entityType: DomainBaseEntities.ReportDefinition,
    id: fieldValue
  };
  let response = await NamaCommon.namaFetch(NamaURLS.FetchReportMetadata, {data: request});
  if (response && response.result && response.result.succeded) {
    reportRef.value = response.data.report;
  }
})

function runReport() {
  let launcherPlace: ReportLauncherPlace = new ReportLauncherPlace();
  launcherPlace.reportId = fieldValue;
  router.push({
    name: RouteNames.LAUNCH_REPORT_ROUTE,
    query: launcherPlace.fetchQuery()
  });
}

</script>

<template>
  <q-item v-if="fieldValue" dense class="tw-px-0 tw-w-full tw-h-full tw-min-h-full">
    <q-item-section class="tw-w-full tw-h-full tw-min-h-full">
      <div class="tw-flex tw-items-center tw-gap-2.5 tw-self-center">
        <a v-text="Translator.translateRef(reportRef)" class="tw-cursor-pointer" @click.stop="runReport" target="_blank"/>
      </div>
    </q-item-section>
  </q-item>
</template>
